import styled from '@benzinga/themetron';
import { NavigationLogo } from '../../../Header/NavigationLogo';
import { LogoVariant } from '@benzinga/logos-ui';
import { FooterNavigationGroup, FooterLink } from '../../footerEntity';
import React from 'react';

interface SimpleFooterProps {
  menu?: FooterNavigationGroup[];
  copyrightLinks?: FooterLink[];
  logoVariant?: LogoVariant;
}

export const SimpleFooter: React.FC<SimpleFooterProps> = ({ copyrightLinks, logoVariant, menu }) => {
  const year = new Date().getFullYear();

  return (
    <FooterWrapper>
      <MainBlock>
        <hr className="border-slate-600 my-4" />
        <div>
          <NavigationLogo deviceType="mobile" logoVariant={logoVariant ?? 'default'} />
        </div>
        <FooterNavigation>
          {menu?.map(group => {
            return (
              <div className="footer-navigation-column" key={group.label}>
                <h4 className="footer-navigation-column-label text-white mb-4">{group.label}</h4>
                <ul>
                  {group?.items?.map(link => {
                    return (
                      <li className="mb-2" key={link.label}>
                        <a className="text-white font-light" href={link.url}>
                          {link.label}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </FooterNavigation>

        <hr className="border-slate-600 my-4" />

        <div className="py-3 flex flex-wrap justify-between items-center">
          <div className="copyright-section text-left  whitespace-nowrap  text-gray-500 font-light text-sm mb-3">
            &copy; {year} Benzinga | All Rights Reserved
          </div>

          <ul className="flex flex-wrap mb-3">
            {copyrightLinks?.map(link => {
              return (
                <li className="footer-navigation-copyright-list-item" key={link.label}>
                  <a
                    className="font-light text-right text-sm text-gray-400 footer-navigation-copyright-link"
                    href={link.url}
                  >
                    {link.label}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </MainBlock>
    </FooterWrapper>
  );
};

export default SimpleFooter;

const FooterWrapper = styled.div`
  background: rgb(9, 52, 81);
  padding-top: 60px;
  padding-bottom: 40px;
`;

const FooterNavigation = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 20px -15px 35px;

  .footer-navigation-column {
    padding: 15px;
    min-width: 200px;
  }
`;

const MainBlock = styled.div`
  max-width: 80%;
  margin: 0 auto;

  .footer-navigation-copyright-list-item {
    &:not(:last-child) {
      .footer-navigation-copyright-link {
        padding-right: 30px;

        &:after {
          content: '';
          top: 50%;
          transform: translateY(-50%);
          right: 15px;
          height: 12px;
          border-right: 1px solid rgba(255, 255, 255, 0.13);
          position: absolute;
        }
      }
    }
  }

  .footer-navigation-copyright-link {
    position: relative;
  }
`;
